const config = {
	"en": {
		"name": "English",
		"csLocaleDir": "en",
		"googleTranslateCode": "en", //https://cloud.google.com/translate/docs/languages
		"numberFormatCode": "en",
		"veeValidateLocaleCode": "en", //References the json file in vee-validate/dist/locale
		"amChartLocaleCode": "en", //https://github.com/amcharts/amcharts4/tree/master/src/lang
		"datepickerLocaleCode": "en", //https://github.com/iamkun/dayjs/tree/dev/src/locale
		"syncFusionLocaleCode": "en-GB" //in node_modules/cldr-data/main/* directory
	},
	"fr": {
		"name": "French",
		"csLocaleDir": "fr",
		"googleTranslateCode": "fr",
		"numberFormatCode": "fr",
		"veeValidateLocaleCode": "fr",
		"amChartLocaleCode": "fr_FR",
		"datepickerLocaleCode": "fr",
		"syncFusionLocaleCode": "fr"
	},
	"es": {
		"name": "Spanish",
		"csLocaleDir": "es",
		"googleTranslateCode": "es",
		"numberFormatCode": "es",
		"veeValidateLocaleCode": "es",
		"amChartLocaleCode": "es_ES",
		"datepickerLocaleCode": "es",
		"syncFusionLocaleCode": "es"
	},
	"bg": {
		"name": "Bulgarian",
		"csLocaleDir": "bg",
		"googleTranslateCode": "bg",
		"numberFormatCode": "bg",
		"veeValidateLocaleCode": "bg",
		"amChartLocaleCode": "en", //apears to be unsupported
		"datepickerLocaleCode": "bg",
		"syncFusionLocaleCode": "bg"
	},
	"ja": {
		"name": "Japanese",
		"csLocaleDir": "ja",
		"googleTranslateCode": "ja",
		"numberFormatCode": "ja-JP",
		"veeValidateLocaleCode": "ja",
		"amChartLocaleCode": "ja_JP",
		"datepickerLocaleCode": "ja",
		"syncFusionLocaleCode": "ja"
	},
	"zh": {
		"name": "Mandarin",
		"csLocaleDir": "zh",
		"googleTranslateCode": "zh-CN",
		"numberFormatCode": "zh-Hans-CN-u-nu-hanidec",
		"veeValidateLocaleCode": "zh_CN",
		"amChartLocaleCode": "zh_Hant",
		"datepickerLocaleCode": "zh",
		"syncFusionLocaleCode": "zh-Hant"
	}
}

export {config as $csLocaleConfig};
